import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";

export default function ConfirmDialog({
  open,
  onOpenChange,
  title = "Are you sure?",
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  destructive = false,
  onConfirm,
  testId = "confirm-dialog",
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={testId} className="bg-white rounded-sm border border-black/10">
        <AlertDialogHeader>
          <AlertDialogTitle data-testid={`${testId}-title`} className="font-display text-xl font-bold text-[#0A0A0A]">{title}</AlertDialogTitle>
          {description && (
            <AlertDialogDescription data-testid={`${testId}-desc`} className="text-[#525252] text-sm">{description}</AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel
            data-testid={`${testId}-cancel`}
            className="border-black/10 text-[#0A0A0A] hover:bg-black/5 rounded-sm"
          >
            {cancelText}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid={`${testId}-confirm`}
            onClick={onConfirm}
            className={`rounded-sm text-white ${destructive ? "bg-[var(--brand-primary)] hover:bg-[var(--brand-primary-hover)]" : "bg-[#0A0A0A] hover:bg-black/80"}`}
          >
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
